import { useSelector } from 'react-redux';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import type { CreditAppSearchResult, DealData } from '../types';
import { mapCurrentDealData, mapToUpdatedDealData } from '../utils/dealDataMappers';

/**
 * Custom hook to fetch current deal data from Redux and format new deal data from selected credit app
 * Returns both current and new deal data for comparison in the review view
 * All values are guaranteed to be strings (never undefined/null), simplifying component logic
 */
export const useDealComparisonData = (selectedCreditApp: CreditAppSearchResult | null) => {
    // Get current deal data from Redux
    const buyerInfo = useSelector(offerReduxSelectors.getShopperInfo);
    const cobuyerInfo = useSelector(offerReduxSelectors.getCoBuyerInfo);

    // Map Redux state to DealData format
    const currentDealData: DealData = mapCurrentDealData(buyerInfo, cobuyerInfo);

    // Map selected credit app to DealData format
    const newDealData: DealData | null = mapToUpdatedDealData(selectedCreditApp?.rawDeal || null);

    return {
        currentDealData,
        newDealData
    };
};
